
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface DebugSectionProps {
  showDebugInfo: boolean;
  setShowDebugInfo: (show: boolean) => void;
  debugOutput: string;
  checkEmployees: () => Promise<void>;
  isLoading?: boolean;
}

const DebugSection = ({ 
  showDebugInfo, 
  setShowDebugInfo, 
  debugOutput, 
  checkEmployees,
  isLoading = false
}: DebugSectionProps) => {
  if (!showDebugInfo) return null;

  return (
    <div className="mt-6 text-xs text-gray-500 border-t pt-4">
      <div className="flex justify-between items-center">
        <h3 className="font-medium">Debug Modus</h3>
        <Button 
          size="sm" 
          variant="ghost" 
          onClick={() => setShowDebugInfo(false)}
        >
          Verbergen
        </Button>
      </div>
      
      <div className="mt-2 flex gap-2">
        <Button 
          size="sm" 
          variant="outline" 
          onClick={checkEmployees}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-3 w-3 animate-spin" />
              Laden...
            </>
          ) : (
            "Bekijk Medewerkers"
          )}
        </Button>
      </div>
      
      {debugOutput && (
        <pre className="mt-2 p-2 bg-black text-green-400 text-xs overflow-auto max-h-60 rounded">
          {debugOutput}
        </pre>
      )}
    </div>
  );
};

export default DebugSection;
